import React from 'react'
import styles from './AsyncLoadingMessage.module.scss'

// react-select's `menuPlacement="auto"` decides top-vs-bottom once, off whatever the menu
// measures at that instant (`getMenuPlacement`'s surrounding effect never re-runs on a content
// change — its dependency array is entirely prop-driven: maxMenuHeight, menuPlacement,
// menuPosition, menuShouldScrollIntoView, minMenuHeight, controlHeight). An async select's
// options arrive AFTER that first measurement, while the menu is still just a one-line loading
// row — so the menu "fits below" at decision time and never revisits it once the real options
// grow it past the viewport. Giving the loading row the SAME height the loaded menu will occupy
// makes that one decision correct from the start — but ONLY for the empty-input default-options
// load: a typed search's loading row is brief and re-measuring on every keystroke would be worse.
export const asyncLoadingMessage = ({ inputValue }: { inputValue: string }) =>
  inputValue ? 'Loading...' : <div className={styles.loadingRow}>Loading...</div>
